/**
 * 缓存
 *
 * @author yusangeng@outlook.com
 */
export var CacheStatus;
(function (CacheStatus) {
    CacheStatus[CacheStatus["NONE"] = 0] = "NONE";
    CacheStatus[CacheStatus["LOADING"] = 1] = "LOADING";
    CacheStatus[CacheStatus["LOADED"] = 2] = "LOADED";
    CacheStatus[CacheStatus["ERROR"] = 3] = "ERROR";
})(CacheStatus || (CacheStatus = {}));
var Cache = /** @class */ (function () {
    function Cache(factory) {
        this.items = {};
        this.factory = factory;
    }
    Cache.prototype.getOrCreateItemByURL = function (key) {
        var ret = this.items[key];
        if (!ret) {
            ret = this.items[key] = this.factory(key);
        }
        return ret;
    };
    Cache.prototype.tryGetItemByURL = function (key) {
        var _a;
        return (_a = this.items[key]) !== null && _a !== void 0 ? _a : null;
    };
    Cache.prototype.removeItemByURL = function (key) {
        var ret = this.items[key];
        if (!ret) {
            return ret;
        }
        this.items[key] = null;
        return ret;
    };
    return Cache;
}());
export { Cache };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FjaGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY2FjaGUvY2FjaGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7R0FJRztBQUlILE1BQU0sQ0FBTixJQUFZLFdBS1g7QUFMRCxXQUFZLFdBQVc7SUFDckIsNkNBQUksQ0FBQTtJQUNKLG1EQUFPLENBQUE7SUFDUCxpREFBTSxDQUFBO0lBQ04sK0NBQUssQ0FBQTtBQUNQLENBQUMsRUFMVyxXQUFXLEtBQVgsV0FBVyxRQUt0QjtBQVlEO0lBSUUsZUFBWSxPQUFvQztRQUhoRCxVQUFLLEdBQTJCLEVBQUUsQ0FBQTtRQUloQyxJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQTtJQUN4QixDQUFDO0lBRUQsb0NBQW9CLEdBQXBCLFVBQXFCLEdBQVc7UUFDOUIsSUFBSSxHQUFHLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQTtRQUV6QixJQUFJLENBQUMsR0FBRyxFQUFFO1lBQ1IsR0FBRyxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLEdBQUcsSUFBSSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQTtTQUMxQztRQUVELE9BQU8sR0FBRyxDQUFBO0lBQ1osQ0FBQztJQUVELCtCQUFlLEdBQWYsVUFBZ0IsR0FBVzs7UUFDekIsT0FBTyxNQUFBLElBQUksQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLG1DQUFJLElBQUksQ0FBQTtJQUNoQyxDQUFDO0lBRUQsK0JBQWUsR0FBZixVQUFnQixHQUFXO1FBQ3pCLElBQU0sR0FBRyxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUE7UUFFM0IsSUFBSSxDQUFDLEdBQUcsRUFBRTtZQUNSLE9BQU8sR0FBRyxDQUFBO1NBQ1g7UUFFRCxJQUFJLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxHQUFHLElBQUksQ0FBQTtRQUV0QixPQUFPLEdBQUcsQ0FBQTtJQUNaLENBQUM7SUFDSCxZQUFDO0FBQUQsQ0FBQyxBQWpDRCxJQWlDQyJ9